import { LoaderFunctionArgs, Outlet } from 'react-router';

import { TCustomRouteObject, THandle } from '@/shared/types/router.types';
import { GatewayFragment } from '@/shared/types/types.generated';

export const gatewayInnerRoutes: TCustomRouteObject[] = [
  {
    path: ':gatewayId/:tabId?',
    lazy: async () => {
      const { Gateway } = await import('./gateway');
      return { Component: Gateway };
    },
    shouldRevalidate: () => false,
    loader: async (args: LoaderFunctionArgs) => {
      const { gatewayLoader } = await import('./gateway');
      return gatewayLoader(args);
    },
    handle: {
      crumb: {
        label: (data: GatewayFragment) => data.name,
      },
    },
  },
];

export const gatewayRouteHandle: THandle = {
  crumb: {
    label: 'gateways',
    localized: true,
  },
  permission: { action: 'gateway:readGateway' },
};

export const gatewayRoutes: TCustomRouteObject = {
  path: '/gateways',
  Component: () => <Outlet />,
  handle: gatewayRouteHandle,
  children: [
    {
      index: true,
      lazy: async () => {
        const { GatewaysListRoute } = await import('./gateways-list');
        return { Component: GatewaysListRoute };
      },
    },
    ...gatewayInnerRoutes,
  ],
};
